import { useState, useEffect } from "react";
import axios from "../axios/index";

const useUserData = (userToken, userData) => {
  const [permissions, setPermissions] = useState(null);
  const [consultantData, setConsultantData] = useState([]);
  const [simpleUser, setSimpleUser] = useState([]);

  useEffect(() => {
    if (userToken !== null && userData?.roles == "") {
      const usersDataHandler = async () => {
        const getUserData = await axios.get("Users/Current", {
          headers: { authorization: "Bearer " + userToken },
        });
        setSimpleUser(getUserData.data.data);
        setPermissions(null);
      };
      usersDataHandler();
    } else if (userToken !== null && userData?.roles) {
      const usersDataHandler = async () => {
        const getConsultantData = await axios.get("Consultant/current", {
          headers: { authorization: "Bearer " + userToken },
        });
        // console.log(getConsultantData)
        setConsultantData(getConsultantData.data.data);

        const roles = userData?.roles;
        if (roles) {
          const userPermissions = await roles?.map(item => item.permissions);
          const permissions = userPermissions.reduce((acc, curr) => acc.concat(curr), []);
          // console.log(permissions);
          setPermissions(permissions);
        }
      };
      usersDataHandler();
    }
  }, [userData, userToken]);

  return { simpleUser, consultantData, permissions };
};

export default useUserData;
